export default {
  normal: {
    leftClick: '左键',
    middleClick: '中键',
    rightClick: '右键',
    dpiInc: 'DPI+',
    dpiDec: 'DPI-',
    forward: '前进',
    back: '后退',
    wheelForward: '滚轮前滚',
    wheelBackward: '滚轮后滚',
    wheelLeft: '滚轮左滚',
    wheelRight: '滚轮右滚',
    diy: 'DIY键',
    fireButton: '火力键',
    sniperButton: '狙击键',
    dpiCycleInc: 'DPI循环+',
    dpiCycleDec: 'DPI循环-',
    configCycle: '配置切换',
    dongleCycle: '接收器切换',
    disableKey: '禁用按键',
  },
  combinedKey: {
    apply: '生效',
    description: '可通过右侧键盘字符进行任意组合, 最多组合3个按键',
    key1: '按键1',
    key2: '按键2',
    key3: '按键3',
  },
  tabs: {
    normal: '常规',
    media: '多媒体',
    config: '配置',
    macro: '宏定义',
    keyboardKeys: '键盘字符',
    combinedKeys: '组合键',
    advanced: '高级改键',
  },
  layers: {
    winDefault: 'Win 默认层',
    winFn: 'Win Fn 层',
    macDefault: 'Mac 默认层',
    macFn: 'Mac Fn 层',
  },
  advancedTypes: {
    RS: 'RS',
    SOCD: 'SOCD',
  },
  advanced: {
    bindingList: '绑定列表',
    create: '新建高级按键',
    empty: '当前高级按键内容为空，点击新建高级按键进行添加',
    selectFunction: '功能选择',
    bindHint: '请点击上方按键或敲击键盘进行绑定',
    modes: {
      mt: {
        title: '按住/单击(MT)',
        excerpt: '单键可区分点击与按，分别触发不同功能',
      },
      tgl: {
        title: '切换开关(TGL)',
        excerpt: '单击按键可开关持续触发，长按则正常触发',
      },
      rs: {
        title: '迅洁(RS)',
        excerpt: '同时按下两个按键时，触发按下键更深的那个按键',
      },
      socd: {
        title: '瞬时释放(SOCD)',
        excerpt: '同时按下两个按键时，根据预设快速触发指定按键',
      },
      dks: {
        title: '动态行程(DKS)',
        excerpt: '将一个按键根据按压和松开的程度不同，绑定1至4种功能',
      },
    },
    deleteDialog: {
      title: '删除高级按键',
      content: '确认删除此高级按键绑定？删除后需重新添加不可恢复',
    },
  },
  videoCarousel: {
    instruction: '点击上方虚拟按键后选择右侧字符，或直接将右侧字符拖拽到上方虚拟按键。',
  },
  targetPanel: {
    restoreKey: '恢复按键',
    restoreFactoryDefault: '恢复出厂默认',
    currentFactoryDefault: '当前为出厂默认',
    factoryDefaultKey: '出厂默认: {label}',
    originalKey: '原按键: {label}',
    mtTooltip: '单击:{click}/长按:{press}',
    tglTooltip: '单击:{click}',
    dksTooltip: '按键: {keys}',
    macroFallback: '宏',
    // V700diy-87 三个灯效功能键的功能描述
    v700BacklightMode: '背光模式切换',
    v700SideLightMode: '侧光模式切换',
    v700BacklightBrightness: '背光亮度切换',
  },
  media: {
    prevTrack: '上一曲',
    playPause: '播放暂停',
    nextTrack: '下一曲',
    stop: '停止',
    mute: '静音',
    volumeUp: '音量+',
    volumeDown: '音量-',
    player: '播放器',
    mail: '邮箱',
    home: '主页',
    calculator: '计算器',
    myComputer: '我的电脑',
    search: '搜索',
    browserBack: '上一页(浏览器)',
    browserForward: '下一页(浏览器)',
    browserRefresh: '刷新(浏览器)',
    browserFavorites: '收藏夹(浏览器)',
    systemPower: '关机',
    systemSleep: '睡眠模式',
    brightnessUp: '亮度+',
    brightnessDown: '亮度-',
    keyboardBrightnessUp: '增加键盘亮度',
    keyboardBrightnessDown: '减少键盘亮度',
    mouseLeft: '鼠标左键',
    mouseRight: '鼠标右键',
    mouseMiddle: '鼠标中键',
    mouseForward: '鼠标前进键',
    mouseBack: '鼠标后退键',
    togLed: 'TOG LED',
    scrollLock: 'Scroll',
    pauseBreak: 'Pause',
    keyHome: 'Home',
    keyEnd: 'End',
    ledColor: 'LED Color',
    winLock: 'WIN Lock',
    ledModeUp: 'LED Mode+',
    ledModeDown: 'LED Mode-',
    ledSpeedUp: 'LED Speed+',
    ledSpeedDown: 'LED Speed-',
    sideLedMode: 'Side LED Mode',
    sideLedColor: 'Side LED Color',
    closeWindow: '关闭窗口',
    lockComputer: '锁定电脑',
    application: '应用',
    showDesktop: '显示桌面',
    zoomInScreen: '放大屏幕',
    zoomOutScreen: '缩小屏幕',
    copy: '复制',
    paste: '粘贴',
    cut: '剪切',
    selectAll: '全选',
  },
  config: {
    quickSwitchConfig: '快捷切换配置',
    quickConfigFile: '快捷配置文件',
    conflictTip: '该功能与“跟随游戏与应用自动切换配置文件”可能形成冲突，请谨慎使用',
    suggestionTip:
      '建议同时在多个配置中设置该功能相同的快捷键，避免使用快捷键由配置A切换到配置B后，无法使用快捷键切回',
    prevConfig: '上一个配置',
    nextConfig: '下一个配置',
    profile: '配置',
  },
  mt: {
    apply: '生效',
    click: '单击',
    longPress: '长按',
    triggerTime: '正常触发按住时间',
    description: '单击为一种按键，长按为另外一种按键',
    guide: '先将左侧按键字符通过拖拽/点击方式，添加到上方的功能框内',
  },
  tgl: {
    apply: '生效',
    sustainedTrigger: '切换开关/持续触发',
    holdTime: '正常触发按住时间',
    description: '单击按键可开关持续触发，长按则为正常触发行为',
    guide: '先将左侧按键字符通过拖拽/点击方式，添加到上方的功能框内',
  },
  dks: {
    intro: '根据按压和松开程度，单次按键最多实现4种功能',
    apply: '生效',
    applyToast: '需要点击“生效”才可以完成 DKS 功能改键',
  },
  rs: {
    title: 'RS 键位绑定',
    apply: '生效',
    key1: '按键1',
    key2: '按键2',
    quickTrigger: '快速触发',
    quickTriggerDescription: '开启后将和RT功能同时生效；可转到“行程页面”对RT功能进行灵敏度调节',
    executePoint: '执行点设置',
    executePointDescription:
      '将绑定的两个按键设置执行点，当两个按键按到执行点高度之后 RS 功能生效；更接近触底的按键先触发；另外一个则释放。完全触底则两个按键同时触发',
  },
  socd: {
    title: 'SOCD 键位绑定',
    apply: '生效',
    key1: '按键1',
    key2: '按键2',
    quickTrigger: '快速触发',
    quickTriggerDescription: '开启后将和RT功能同时生效；可转到“行程页面”对 RT 功能进行灵敏度调节',
    executePoint: '执行点设置',
    bottomTrigger: '完全触底则两个按键同时触发',
    executePointDescription:
      '将绑定的两个按键设置执行点。当两个按键按到执行点高度之后 SOCD 功能生效',
    methods: {
      rearCover: {
        title: '后覆盖',
        excerpt: '后按下的按键先触发，先按下的释放；先按下的按键需要完全抬起再按下，才可以重新触发',
      },
      absolutePriority: {
        title: '绝对优先触发',
        excerpt:
          '可将其中一个按键选中为绝对优先触发，不管未选中按键处于什么状态，选中按键按下时，都优先触发',
      },
      conflict: {
        title: '冲突',
        excerpt: '两个按键同时按下时，都不触发，当完全抬起其中一个按键，另外一个按键触发',
      },
    },
  },
  macro: {
    label: 'Macro',
    rightClickEdit: '右键进行编辑',
    addTip: '上方新建宏文件或者直接点击"开始录制"按钮吧~',
    buttons: {
      import: '导入',
      export: '导出',
      locate: '定位到当前宏文件',
      cancelSelection: '取消选择',
      create: '新建',
      cancel: '取消',
      delete: '删除',
      tip: '部分网络游戏对使用快捷键或宏编程功能可能会判定为外挂作弊，有封号处罚风险',
    },
    deleteDialog: {
      title: '删除宏定义文件',
      content: '确认删除此宏文件，删除后需重新添加不可恢复',
    },
    toolbar: {
      loopCount: '循环次数',
      togglePlayback: '使用指派按键切换开/关播放',
      playOnPress: '按下时播放',
      startRecording: '开始录制',
      input: '可输入',
      delaySet: '延迟间隔设置',
      delaySetContent: '统一所有事件之间的执行间隔，最小延迟 2ms',
    },
    menu: {
      key: '按键',
      delay: '延迟',
      coordinate: '坐标',
    },
    wheel: {
      forward: '滚轮上滚',
      backward: '滚轮下滚',
      left: '滚轮左滚',
      right: '滚轮右滚',
    },
  },
}
